import api from "@helpers/api";

import { URLS } from "@constants/urls";

import { PaginationRequestType } from "@type/HRM/pagination";

const { TICKETS } = URLS;

const apiEndPoint = `${process.env.REACT_APP_E_TICKETING_SERVICE_BASE_URL}${process.env.REACT_APP_E_TICKETING_SERVICE_PORT}/${process.env.REACT_APP_E_TICKETING_SERVICE}/api/${process.env.REACT_APP_API_VERSION}/${process.env.REACT_APP_API_PRIVATE}/${TICKETS}`;

export const getTickets = (() => {
  return async (data: PaginationRequestType, url?: string) => {
    const {
      page,
      size,
      search,
      type,
      category,
      unit,
      priority,
      status,
      assignedTo,
      from,
      to,
    } = data;

    return api
      .get(url ? `${apiEndPoint}/${url}` : apiEndPoint, {
        params: {
          page,
          size,
          search,
          type,
          category,
          unit,
          priority,
          status,
          assignedTo,
          from,
          to,
        },
      })
      .then((response) => {
        const { data, page, size, total } = response.data;

        return {
          data,
          pagination: {
            page,
            size,
            total,
          },
        };
      });
  };
})();
